import React from 'react';
import { Helmet } from 'react-helmet-async';
import ChangeInsightAnswersRespondentContainer from '../../../containers/change-insights/ChangeInsightAnswersRespondentContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const SurveyPage = ({
  slug,
  token,
  responseId,
  initiativeType,
  initiativeId,
  surveyId,
}) => {
  return (
    <>
      <Helmet>
        <title>Response Feedback Form | ChangeSync</title>
      </Helmet>
      <ChangeInsightAnswersRespondentContainer
        token={token}
        slug={slug}
        surveyId={surveyId}
        responseId={responseId}
        disabled
        initiativeId={initiativeId}
        initiativeType={initiativeType}
      />
    </>
  );
};

SurveyPage.getInitialProps = ({ query }) => ({
  surveyId: query ? query.surveyId : '',
  responseId: query ? query.responseId : '',
  initiativeId: Number(query.initiativeId),
  initiativeType: query.initiativeType,
  slug: query.slug,
});

export default requireAuth(withRouterParams(SurveyPage));
